import { CHANGE_LOCATION } from '@gogame/screens';

export const SET_PARTNER = 'SET_PARTNER';

export default function(state, action) {
  switch (action.type) {
    case CHANGE_LOCATION:
      // url state
      return action.payload;
    case SET_PARTNER:
      // url state
      return {
        ...state,
        partner: action.payload,
      };
    default:
      return state;
  }
}
